<div class="flex flex-wrap justify-content-between align-items-center my-3">
    <h2 class="m-0 font-semibold text-base">Webhooks</h2>
    <div class="flex gap-2">
        <p-button styleClass="add-button" label="Add webhook" severity="primary" [rounded]="true" (onClick)="openAddPaymentWebhookDialog()">
            <ng-template #icon>
                <img src="assets/icons/Add.svg" alt="Send" />
            </ng-template>
        </p-button>
    </div>
</div>

<p-card class="border-round-2xl w-full bg-white">
    <div class="table-header flex flex-wrap justify-content-between align-items-center mb-3 gap-3">
        <div class="flex flex-row flex-wrap gap-2 align-items-center justify-content-center">
            <h2 class="table-title m-0">Payment webhook</h2>
        </div>
    </div>
    <p-table [value]="paymentWebhookList()">
        <ng-template #header>
            <tr>
                <th class="t-head">ID</th>
                <th class="t-head">Address</th>
                <th class="t-head">Key</th>
                <th class="t-head">Enabled</th>
                <th class="t-head">Failed</th>
                <th class="t-head">Actions</th>
            </tr>
        </ng-template>
        <ng-template #body let-paymentWebhook>
            <tr>
                <td class="t-body">{{ paymentWebhook.id }}</td>
                <td class="t-body">{{ paymentWebhook.address }}</td>
                <td class="t-body">{{ paymentWebhook.hmacKey }}</td>
                <td class="t-body">
                    @if(paymentWebhook.enabled) {
                    <i class="fa-regular fa-circle-check text-green-500"></i>
                    }@else {
                    <i class="fa-regular fa-circle-xmark text-red-500"></i>
                    }
                </td>
                <td class="t-body">
                    @if(paymentWebhook.failed) {
                    <i class="fa-regular fa-circle-check text-green-500"></i>
                    }@else {
                    <i class="fa-regular fa-circle-xmark text-red-500"></i>
                    }
                </td>
                <td class="t-body">
                    <div class="flex align-items-center justify-center gap-2">
                        <p-button text="true" (onClick)="openDeletePaymentWebhookDialog(paymentWebhook)" pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="tooltip">
                            <ng-template pTemplate="icon">
                                <img src="assets/icons/delete.svg" alt="delete" />
                            </ng-template>
                        </p-button>
                        <p-button text="true" (onClick)="openEnableDisablePaymentWebhookDialog(paymentWebhook)" [pTooltip]="paymentWebhook.enabled ? 'Disable' : 'Enable'" tooltipPosition="top" tooltipStyleClass="tooltip">
                            <ng-template pTemplate="icon">
                                @if(paymentWebhook.enabled) {
                                <i class="fa-regular fa-circle-xmark text-red-500"></i>
                                }@else {
                                <i class="fa-regular fa-circle-check text-green-500"></i>
                                }
                            </ng-template>
                        </p-button>
                        <p-button text="true" (onClick)="openTestPaymentWebhookDialog(paymentWebhook)" pTooltip="Test" tooltipPosition="top" tooltipStyleClass="tooltip">
                            <ng-template pTemplate="icon">
                                <i class="fa-solid fa-paper-plane text-blue-500"></i>
                            </ng-template>
                        </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>

@defer (when addPaymentWebhookDialog; prefetch on idle) {
<app-add-payment-webhook-form (addedPaymentWebhook)="onPaymentWebhookAdded()" [(visibility)]="addPaymentWebhookDialog" />
}

@defer (when deletePaymentWebhookDialog; prefetch on idle) {
<app-delete-payment-webhook-form (deletedPaymentWebhook)="onPaymentWebhookDeleted()" [selectedPaymentWebhook]="selectedPaymentWebhook" [(visibility)]="deletePaymentWebhookDialog" />
}

@defer (when enableDisablePaymentWebhookDialog; prefetch on idle) {
<app-enable-disable-payment-webhook-form (paymentWebhookStatusChanged)="onPaymentWebhookStatusChanged()" [selectedPaymentWebhook]="selectedPaymentWebhook"
    [(visibility)]="enableDisablePaymentWebhookDialog" />
}

@defer (when testPaymentWebhookDialog; prefetch on idle) {
<app-test-payment-webhook-form (testedPaymentWebhook)="onPaymentWebhookTested()" [selectedPaymentWebhook]="selectedPaymentWebhook" [(visibility)]="testPaymentWebhookDialog" />
}